export default __webpack_public_path__ + "static/media/hall_of_fame_bar_2.b792eb67.png";